import React, { useState, useEffect } from "react";
import "./MyNft.css";
import NftTransferModel from "../../Model/NftTransferModel";
import { getNftData } from '../MyNFT/MyNftData'; // Ensure this path is correct
import hh from "../../assets/image.jpg"

const MyNFT = ({ connect, address }) => {
  const [myNftCardData, setMyNftCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // Set to 6 for displaying 6 NFTs per page

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getNftData(address);
        setMyNftCardData(data);
      } catch (error) {
        console.error("Error fetching NFTs:", error);
      }
    };
    
    if (address) {
      fetchData();
    }
  }, [address]);

  // Calculate the index of the first and last item in the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = myNftCardData.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate the total number of pages
  const totalPages = Math.ceil(myNftCardData.length / itemsPerPage);

  // Generate the page numbers
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="bgHomeColor pt-5">
      <div className="bgHomeColor">
        <div className="container py-5 relative">
          <div className="row justify-content-center align-items-center">
            <div className="col-10 col-lg-11 bg-mynft-box">
              <div className="row justify-content-sm-center justify-content-md-start">
                <div className="d-flex justify-content-end p-3"></div>
                <h3 className="text-center fw-bold color">MY NFT</h3>
                {currentItems.length > 0 ? (
                  currentItems.map((currElement) => {
                    const { Id, image, description, title } = currElement;
                    return (
                      <div
                        className="col-12 col-md-6 col-lg-4 gx-5 gy-3"
                        key={Id}
                      >
                        <div className="card bgHomeColor2 p-3">
                          <img
                            src={image}
                            className="card-img-top img-fluid"
                            alt={title}
                          />
                          <div className="card-body d-flex justify-content-between">
                            <div>
                              <h5 className="card-title fw-bold text-white">
                                {title}
                              </h5>
                              <p className="card-text fw-bold text-white">
                                {description}
                              </p>
                            </div>
                            {/* Uncomment and customize the transfer button if needed */}
                            {/* <div className="text-white">
                              <button
                                className="btn nft-transfer-btn fw-bold"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModale"
                              >
                                Transfer
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center fw-bold text-white">No NFTs found</p>
                )}

                <div className="pt-3 d-flex justify-content-center">
                  <nav aria-label="Page navigation example">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link pg-previous"
                          aria-label="Previous"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      {pageNumbers.map((pageNumber) => (
                        <li
                          className={`page-item ${pageNumber === currentPage ? "active" : ""}`}
                          key={pageNumber}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link pg-next"
                          aria-label="Next"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NftTransferModel />
    </div>
  );
};

export default MyNFT;
